window.onload = (event) => {
  const relatedProducts = document.querySelector('.shopify-section.related-products')
  const content = document.querySelector('.shopify-section.article-section')

  if(!content) return;


  let copyRelatedProducts = document.createElement('span');
  if (relatedProducts) {
    copyRelatedProducts = relatedProducts.cloneNode(true);
    copyRelatedProducts.id = 'copy-' + relatedProducts.id;
    copyRelatedProducts.querySelectorAll('style').forEach(styleTag => styleTag.remove());
    copyRelatedProducts.setAttribute('data-clone', 'true');
  }

  let newContent = content.innerHTML ;

  newContent = newContent.replaceAll('[products-related]', copyRelatedProducts.outerHTML);

  content.innerHTML = newContent;
};
